import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import useBreakpoint from "../../../hooks/useBreakpoint";
import "swiper/css";
import "swiper/css/navigation";

import { ArticleCard } from "./";
import "./articles.css";

export default function ArticlesSection({ articles = [] }) {
  const isDesktop = useBreakpoint();

  const homepageArticles = articles.slice(0, 8);

  const firstRow = homepageArticles.slice(0, 4);
  const secondRow = homepageArticles.slice(4, 8);

  return (
    <section className="home-articles">
      <div className="container">
        <div className="home-articles-header">
          <div className="home-articles-header__title">
            مجله سلامت  کافه دارو 
          </div>

          <div className="home-articles-header__center">
            {/* <span></span> */}
          </div>


          
          <Link to="/مجله-سلامت" className="home-articles-header__more">
            <span>مشاهده همه </span>
            

            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </Link>
        </div>

        {isDesktop ? (
          // <div className="home-articles-grid">
          //     {homepageArticles.map(article => (
          //         <ArticleCard
          //             key={article.id}
          //             article={article}
          //         />
          //     ))}
          // </div>

          <div className="home-articles-desktop">
            <div className="home-articles-row">
              {firstRow.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>

            <div className="home-articles-row">
              {secondRow.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        ) : (
          <Swiper
            modules={[Navigation]}
            navigation={false}
            spaceBetween={20}
            breakpoints={{
              0: {
                slidesPerView: 1.1,
              },
              576: {
                slidesPerView: 3.1,
              },
              768: {
                slidesPerView: 3.5,
              },
            }}
          >
            {homepageArticles.map((article) => (
              <SwiperSlide key={article.id}>
                <ArticleCard article={article} />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </section>
  );
}
